import { SHContainer, SHStack } from "@components/design-systems";
import { ModelScreenerToolbarSkeleton } from "@pages/managed-accounts/model-screener/components/model-screener-skeleton/toolbar-skeleton";
import { ModelScreenerTableSkeleton } from "@pages/managed-accounts/model-screener/components/model-screener-skeleton/table-skeleton";
import React from "react";

export const ModelScreenerSkeleton = () => {
  return (
    <SHStack spacing={3}>
      <SHContainer sx={{ px: { xs: 0 } }}>
        <SHStack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <ModelScreenerToolbarSkeleton />
        </SHStack>
      </SHContainer>
      <ModelScreenerTableSkeleton />
    </SHStack>
  );
};
